import { IDescriptionData } from "../models"

export const parseDesctionData = (params?: string): IDescriptionData | undefined => {
  try {
    const data = JSON.parse(params ?? 'error') as IDescriptionData
    if (typeof data.index === 'number') return data
  } catch (error) {}
}